import {
  Component,
  Input
} from '@angular/core';
import {
  IonicPage,
  NavController,
  NavParams,
  PopoverController,
  ModalController
} from 'ionic-angular';
import {
  FacilityProvider
} from '../../providers/facility/facility';
import {
  BookingPage
} from '../booking/booking';
import {
  FacilityPage
} from '../facility/facility'
import {
  PopoverPage
} from '../popover/popover';
import {
  TranslateService
} from '@ngx-translate/core';
import {
  ToastProvider
} from '../../providers/toast/toast';
import {
  ViewController
} from 'ionic-angular/navigation/view-controller';
import {
  max
} from 'moment';

@IonicPage()
@Component({
  selector: 'page-facility-select-location',
  templateUrl: 'facility-select-location.html',
})
export class FacilitySelectLocationPage {

  locations: any;
  page: any;
  color: any;
  pageRow = false;
  pageColumn = true;
  collapMore = false;
  selRegistrationLogin: any;
  valueData: any;
  statuses:{};
  @Input() view: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams, private translate: TranslateService,
    private viewCtrl: ViewController,
    public popoverCtrl: PopoverController,
    private modalCtrl: ModalController,
    private toast: ToastProvider,
    private facilityProvider: FacilityProvider,
  ) {
    this.valueData = {
      name: this.navParams.get("name"),
      phone_no: this.navParams.get("mobile"),
      date: this.navParams.get("date") ? this.navParams.get("date") : new Date(),
      type: this.navParams.get("type") ? this.navParams.get("type") : 'AMENITY',
      openModal: this.navParams.get("openModal") ? this.navParams.get("openModal") : false,
      pass_id: this.navParams.get("pass_id") ? this.navParams.get("pass_id") : ''
    }

    this.page = 'column';
    let locations = this.navParams.get("locations");
    this.selRegistrationLogin = localStorage.getItem('signup_login')

    if (this.selRegistrationLogin) {
      // this.toast.presentToast("You are Unauthorized to use this feature , Please request to admin.");
    } else {
      if (locations) {
        this.locations = locations;
        this.decode();
      } else {
        this.facilityProvider.getLocations(this.valueData.type).then(val => {
          if (val.status == "success") {
            this.locations = val.data;

            this.locations.forEach((val) => {
              if (val.data) {
                val.data = JSON.parse(val.data)
              }
              if (val.rules) {
                val.rules = JSON.parse(val.rules)
                // val.rules.pre_defined_slot_only = 1,
                // val.rules.no_of_future_days = 30
              }

            })
            // var data = {
            //   address: "Noida",
            //   availability_days: null,
            //   availability_slot: null,
            //   description: "mnnn",
            //   icon: "https://ism-complaint-mirror.s3.amazonaws.com/public/Facility/21/60f580215ddb0_TDOa01AJJ7DAMmLmEcrS2021071913_new0.31696381184114486.png",
            //   id: 100,
            //   image: [""],
            //   is_booking: 1,
            //   type:'PARKING',
            //   name: "tennnis",
            //   rules: {"no_of_future_days": 30,"pre_defined_slot_only":1,"max_per_day":3},
            //   slot: {"0":{"avl":true,"hrs":[{"$$hashKey":"5E7","from":"09:00","to":"21:00"}]},"1":{"avl":true,"hrs":[{"$$hashKey":"5EF","from":"09:00","to":"10:00"},{"from":"10:00","to":"11:00","$$hashKey":"5FG"},{"from":"11:00","to":"12:00","$$hashKey":"5FJ"},{"from":"12:00","to":"13:00","$$hashKey":"5FM"},{"from":"19:00","to":"20:00","$$hashKey":"5FP"},{"from":"20:00","to":"21:00","$$hashKey":"5FV"}]},"3":{"avl":true,"hrs":[{"$$hashKey":"5EN","from":"09:00","to":"10:00"},{"from":"10:00","to":"11:00","$$hashKey":"5FY"},{"from":"11:00","to":"12:00","$$hashKey":"5G1"},{"from":"12:00","to":"13:00","$$hashKey":"5G4"},{"from":"19:00","to":"20:00","$$hashKey":"5G7"},{"from":"20:00","to":"21:00","$$hashKey":"5GB"}]},"4":{"avl":true,"hrs":[{"$$hashKey":"5EV","from":"09:00","to":"10:00"},{"from":"10:00","to":"11:00","$$hashKey":"5GE"},{"from":"11:00","to":"12:00","$$hashKey":"5GH"},{"from":"12:00","to":"13:00","$$hashKey":"5GK"},{"from":"13:00","to":"14:00","$$hashKey":"5GN"},{"from":"14:00","to":"15:00","$$hashKey":"5GQ"},{"from":"15:00","to":"16:00","$$hashKey":"5GT"},{"from":"19:00","to":"20:00","$$hashKey":"5GW"},{"from":"20:00","to":"21:00","$$hashKey":"5H0"}]},"5":{"avl":true,"hrs":[{"$$hashKey":"5F3","from":"09:00","to":"10:00"},{"from":"10:00","to":"11:00","$$hashKey":"5H3"},{"from":"11:00","to":"12:00","$$hashKey":"5H6"},{"from":"12:00","to":"13:00","$$hashKey":"5H9"},{"from":"13:00","to":"14:00","$$hashKey":"5HC"},{"from":"14:00","to":"15:00","$$hashKey":"5HF"},{"from":"15:00","to":"16:00","$$hashKey":"5HI"},{"from":"19:00","to":"20:00","$$hashKey":"5HL"},{"from":"20:00","to":"21:00","$$hashKey":"5HP"}]},"6":{"avl":true,"hrs":[{"$$hashKey":"5FB","from":"09:00","to":"10:00"},{"from":"10:00","to":"11:00","$$hashKey":"5HS"},{"from":"11:00","to":"12:00","$$hashKey":"5HV"},{"from":"12:00","to":"13:00","$$hashKey":"5HY"},{"from":"13:00","to":"14:00","$$hashKey":"5I1"},{"from":"14:00","to":"15:00","$$hashKey":"5I4"},{"from":"15:00","to":"16:00","$$hashKey":"5I7"},{"from":"19:00","to":"20:00","$$hashKey":"5IA"},{"from":"20:00","to":"21:00","$$hashKey":"5IE"}]}},
            //   society_id: 21,
            //   updated_at: "2021-07-19 13:41:47",
            //   updated_by: "20604"
            // }
            // this.locations.push(data)
            this.decode();
          }
        });
      }
    }
  }

  decode() {
    let days = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
    let colors = ['#0167b1', '#20639b', '#3caea3', '#f6d55c', '#173f5f', '#173f5f'];
    this.statuses={}
    this.locations.forEach(location => {
      this.statuses[location.id]= this.getBookingStatus(location)

      if (location.slot) {
        if (typeof location.data == 'string') {
          location.data = JSON.parse(location.data)
        }
        if (typeof location.rules == 'string') {
          location.rules = JSON.parse(location.rules)
        }
        // if(typeof location.availability_days == 'string')
        // location.availability_days = JSON.parse(location.availability_days);
        if (typeof location.slot == 'string')
          location.slot = JSON.parse(location.slot);
        if (typeof location.no_availability_days == 'string')
          location.no_availability_days = JSON.parse(location.no_availability_days);
        let temp = "";
        days.forEach((x, index) => {
          // if(location.availability_days.includes(index.toString())){
          //   temp += x + ' ';
          // }
          if (location.slot && location.slot[(index)]) {
            temp += x + ' ';
            location.availability_slot = location.slot[(index)].hrs;
          } else {
            temp += '• ';
          }
        });
        location.disp_days = temp;
      } else {
        location.disp_days = '. . . . . . .';
      }
      // if(location.availability_slot && typeof location.availability_slot == 'string')
      // location.availability_slot = JSON.parse(location.availability_slot);
      this.color = []
      if (location.rules && location.rules.show_availability) {
        this.facilityProvider.checkSlotBooked(location.id, null).then(val => {
          if (val.status == "success" && val.data) {
            location.bookings_today = val.data.length;
            this.setColor(location)
          } else {
            location.bookings_today = 0
            this.setColor(location)
          }
        });
      }

    });
  }
  setColor(location) {
    let c = 'green'
    let today = location.bookings_today
    let max = location.rules.max_per_day
    if(max){
      let per = (today/max) * 100
      if (per>80) {
        c = 'indianred'
      }else if (per>40) {
        c = 'yellowgreen';
      }else if (today < max) {
        c = 'green';
      } 
    }
    this.color[location.id] = c
  }

  changeViewRow() {
    this.pageRow = true;
    this.pageColumn = false;
  }
  changeViewColumn() {
    this.pageColumn = true;
    this.pageRow = false;
  }

  presentPopover(myEvent) {
    if (this.selRegistrationLogin) {
      this.toast.presentToast("You are Unauthorized to use this feature , Please request to admin.");
    } else {
      let popover = this.popoverCtrl.create(PopoverPage, {
        parentPage: this,
        options: [{
          title: this.translate.instant('MY_BOOKING'),
          handler: function (that) {
            console.log(that)
            that.bookings(FacilityPage);
          }
        }, ]
      });
      popover.present({
        ev: myEvent
      });
    }
  }
  openMyBookings() {
    this.navCtrl.push(FacilityPage);
  }

  doRefresh(refresher) {
    if (this.selRegistrationLogin) {
      setTimeout(() => {
        refresher.complete()
      }, 2000)
    } else {
      this.facilityProvider.getLocations(this.valueData.type).then(val => {
        if (val.status == "success") {
          this.locations = val.data;
          this.locations.forEach((val) => {
            if (val.data) {
              val.data = JSON.parse(val.data)
            }
            if (val.rules) {
              val.rules = JSON.parse(val.rules)
            }
          })
          this.decode();
        }
        refresher.complete();
      }).catch(e => {
        refresher.complete();
      });
    }
  }

  book(location: any) {
    location.valueData = this.valueData
    if (location.valueData.openModal) {
      let modal = this.modalCtrl.create(BookingPage, {
        location
      });
      modal.present();
      modal.onDidDismiss(data => {
        if (data) {
          this.dismissModal(data)

        }
      });

    } else {
      this.navCtrl.push(BookingPage, {
        location
      });
    }

  }

  bookings() {
    this.navCtrl.push(FacilityPage, {
      type: this.valueData.type
    });
  }

  dismissModal(data) {
    data = data ? data : ''
    this.viewCtrl.dismiss(data);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad FacilitySelectLocationPage');
  }
  getBookingStatus(location){
    return this.facilityProvider.getBookingStatus(location)
   }
}


// WEBPACK FOOTER //
// ./src/pages/facility-select-location/facility-select-location.ts